import { createAction, props } from '@ngrx/store';
import { ChatStatus } from 'src/app/core/models/chatStatus.model';

export const OpenFilters = createAction('[Nav] Open filters');
export const CloseFilters = createAction('[Nav] Close filters');

export const OpenMenu = createAction('[Nav] Open menu');
export const CloseMenu = createAction('[Nav] Close menu');
export const ToggleMenu = createAction('[Nav] Toggle menu');

export const SetTheme = createAction('[Nav] Set Theme', props<{ theme: string }>());
export const SetDefaultTheme = createAction('[Nav] Set Default Theme', props<{ theme: string }>());
export const SetNavTransparency = createAction('[Nav] Set nav transparency', props<{ transparent: boolean }>());

export const ResetTheme = createAction('[Nav] Reset Theme');

export const OpenCart = createAction('[Cart Pane] Open cart');
export const CloseCart = createAction('[Cart Pane] Close cart');
export const ToggleCart = createAction('[Cart Pane] Toggle cart');

export const OpenSearch = createAction('[Search] Open search');
export const CloseSearch = createAction('[Search] Close search');

export const SetChatStatus = createAction('[Nav] Set chat status', props<{ status: ChatStatus }>());
